import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../app/stores/store';
import ResetPasswordEmailForm from './ResetPasswordEmailForm';
import { Box, Button, Grid, Typography } from '@mui/material';
import logoWhite from '../../../assets/HomePic2.jpg';
import Login from './Login';
import { withNavbar } from '../../../app/layout/HOC';

const styles = {
    root: {
        margin: '0 auto',
        width: 400,
        height: 260,
        padding: '30px 50px 10px 50px',
        marginTop: 30,
        boxShadow: '3px 3px 7px 1px #ccc',
        background: '#FFFFFF',
        '& h6': {
            marginTop: 2,
        },
    } as const,
    displayCursor: {
        cursor: 'pointer'
    },
    backgroundPic: {
        marginTop: 50,
        backgroundImage: `url(${logoWhite})`,
        backgroundRepeat: 'no-repeat',
        minHeight: '100%',
        width: '100%',
        height: 'auto',
        position: 'fixed',
        top: 0,
        left: 100,
        zIndex: -1,
    },
}

const ResetPasswordValidate = () => {
    const { userStore, modalStore } = useStore();
    const { isResetPassword } = userStore;
    const { openModal } = modalStore;

    return (
        <div>
            <Grid container >
                <Box sx={styles.root}>
                    {isResetPassword ? <><Typography variant="h6">Password reset successfully</Typography>
                        <Button type="submit" sx={{ mt: 3 }} variant="contained" onClick={() => openModal(<Login />)}> Login </Button> </>
                        : <> <Typography variant="h6">There has been an error in your password resetting process. Try again</Typography>
                            <Button sx={{ mt: 3 }} type="submit" variant="contained" onClick={() => openModal(<ResetPasswordEmailForm />)}>Resend Email</Button></>}
                </Box>
            </Grid>
        </div>
    )
}
const ResetPasswordValidatePage = withNavbar(observer(ResetPasswordValidate));
export default ResetPasswordValidatePage;